export default __webpack_public_path__ + "static/media/EM1200.34I-31128_-17716_0.e37ed54a.jpg";